import React from "react";
import { useFormContext } from "react-hook-form";

import { AutoFormFieldProps } from "@autoform/react";

import { Textarea } from "@/components/ui/textarea";

export type ITextAreaFieldCustomData = {};

export const TextAreaField: React.FC<AutoFormFieldProps> = ({
  id,
  inputProps,
}) => {
  const form = useFormContext();
  const value = form.watch(id);
  const { key, ...rest } = inputProps;

  return (
    <Textarea
      value={value ?? ""}
      key={key}
      {...rest}
      className="min-h-[160px]"
    />
  );
};
